import { create } from 'zustand';
import { getCatalogMeta, getCatalogSkins } from '../lib/api';
import type { CatalogMeta, CatalogSkin } from '../types';

interface CatalogState {
  skins: CatalogSkin[];
  skinsByKey: Map<string, CatalogSkin>;
  meta: CatalogMeta | null;
  loading: boolean;
  error: string | null;
  loaded: boolean;
  load: () => Promise<void>;
}

export const useCatalogStore = create<CatalogState>((set, get) => ({
  skins: [],
  skinsByKey: new Map(),
  meta: null,
  loading: false,
  error: null,
  loaded: false,
  load: async () => {
    if (get().loaded || get().loading) return;
    set({ loading: true, error: null });
    try {
      const [skins, meta] = await Promise.all([getCatalogSkins(), getCatalogMeta()]);
      set({
        skins,
        skinsByKey: new Map(skins.map((s) => [s.key, s])),
        meta,
        loading: false,
        loaded: true,
      });
    } catch (err) {
      set({ loading: false, error: err instanceof Error ? err.message : 'failed to load catalog' });
    }
  },
}));
